import { BadgeCard, Button, DeleteIcon, GridColumn, GridRow, Input, ValueField } from '@bp/ui-components';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { LessonFormType } from '../../types';

type EpochLessonUnitFormItemProps = {
  index: number;
  disabled: boolean;
  onDelete: () => void;
};

export const EpochLessonUnitFormItem = ({ index, disabled, onDelete }: EpochLessonUnitFormItemProps) => {
  const { t } = useTranslation();

  const { values, handleChange } = useFormikContext<LessonFormType>();

  return (
    <GridRow spacingBottom='m' spacingTop='none'>
      <GridColumn width={10}>
        <GridRow spacingBottom='none' spacingTop='none'>
          <GridColumn width={3}>
            <Input
              readonly={disabled}
              type='number'
              label={t('lessonUnit.duration')}
              name={`lessonUnit.${index}.duration`}
              onChange={handleChange}
              value={values.lessonUnit ? (values.lessonUnit[index].duration ?? undefined) : undefined}
              suffix={t('common.hour', { count: 2 })}
            />
          </GridColumn>
          <GridColumn width={3}>
            <Input
              readonly={disabled}
              type='number'
              label={t('common.count')}
              name={`lessonUnit.${index}.count`}
              onChange={handleChange}
              value={values.lessonUnit ? (values.lessonUnit[index].count ?? undefined) : undefined}
            />
          </GridColumn>
          <GridColumn width={3}>
            {values.lessonUnit && values.lessonUnit[index] && values.lessonUnit[index].duration && (
              <ValueField title={t('badgeCard.preview')} position='top'>
                <BadgeCard
                  label={values.subject?.name.slice(0, 2).toUpperCase() ?? ''}
                  count={Number(values.lessonUnit[index].count ?? 0)}
                  width={
                    Math.abs(Math.min(Math.floor(Number(values.lessonUnit[index].duration ?? 0)), 4)) as 1 | 2 | 3 | 4
                  }
                />
              </ValueField>
            )}
          </GridColumn>
        </GridRow>
      </GridColumn>

      <GridColumn width={2} className='mt-5' align='end'>
        <Button hierarchy='tertiary' disabled={disabled} onClick={onDelete} icon={<DeleteIcon />} />
      </GridColumn>
    </GridRow>
  );
};
